import { BrowserRouter } from 'react-router-dom';
import { useSelector } from "react-redux";
import AppRoutes from './AppRoutes'
import './i18n';
import './sass/base/general.sass'

function App() {
  const isAuthenticated = useSelector(state => state.auth.isAuthenticated);
  return (
    <BrowserRouter>
      <AppRoutes isAuthenticated={isAuthenticated}  />
    </BrowserRouter>
  );
}

export default App;